import { applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

const IS_PRODUCTION = process.env.NODE_ENV === 'production';

export const rootMiddleware = IS_PRODUCTION
  ? applyMiddleware(thunk)
  : composeWithDevTools(applyMiddleware(thunk));
